export const UPDATE = 'page-data/UPDATE';
export const UPDATE_ONE = 'page-data/UPDATE_ONE';
